import { Builder } from '@builder.io/react'

import { SKUSelectionCtaDefaults } from '@src/components/SKUSelectionCta/SKUSelectionCta.defaults'

import { SKUSelectionCta } from './SKUSelectionCta'

Builder.registerComponent(SKUSelectionCta, {
  name: 'SKUSelectionCta',
  noWrap: true,
  inputs: [
    {
      name: 'copy',
      type: 'text',
      localized: true,
      defaultValue: SKUSelectionCtaDefaults.copy,
    },
    {
      name: 'redirectUrl',
      type: 'text',
      defaultValue: SKUSelectionCtaDefaults.redirectUrl,
    },
    {
      name: 'extraSkus',
      friendlyName: 'Extra SKUs',
      localized: true,
      type: 'array',
      subFields: [
        {
          name: 'sku',
          type: 'string',
        },
      ],
      defaultValue: SKUSelectionCtaDefaults.extraSkus,
    },
    {
      name: 'bundleId',
      type: 'string',
      localized: true,
    },
  ],
})
